module.exports = __webpack_public_path__ + "img/logo.621f8377.png";